export interface IScheduleFrequency {
  scheduleType: string; // Hourly, Daily, Weekly, Monthly
  scheduleDetails: IScheduleDetails;
}

export interface ISchedule extends IScheduleFrequency {
  id: string;
  name: string;
  scheduledAction: string; // Extract, Subscription
  priority: number;
  taskCount: number;
  parallel: boolean;
  runNextAt?: string; // YYYY-MM-DDThh:mm:ssZ - not present if disabled.
  serverTimezoneOffset: number;
  definedBy?: string;
  timeZoneDisplayName?: string; // e.g. (UTC-08:00) America/Los_Angeles
  enabledForLinkedTasks?: boolean;
}

export interface IScheduleDetails {
  startTime: number;          // Time at which the schedule runs. Represented as minutes past midnight.
}

export let ScheduleTypes = {
  Hourly: 'Hourly',
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly'
};

export let ScheduleActions = {
  Extract: 'Extract',
  Flow: 'Flow',
  Subscription: 'Subscription',
  Data_Acceleration: 'Data_Acceleration',
};

export interface IHourlySchedule extends IScheduleDetails {
  endTime: number;               // Time at which the schedule stops recurring. Represented as minutes past midnight.
  recurrenceMinutes: number;     // Minutes between each recurrence.
  recurrenceDaysOfWeek?: string[]; // Days of week to run.
}

export interface IDailySchedule extends IScheduleDetails {
  endTime?: number;               // Time at which the schedule stops recurring. Represented as minutes past midnight.
  recurrenceMinutes?: number;     // Minutes between each recurrence.
  recurrenceDaysOfWeek?: string[] ; // Days of week to run.
}

export interface IWeeklySchedule extends IScheduleDetails {
  recurrenceDaysOfWeek: string[]; // Days on which the schedule runs. Range: Sun, Mon, Tue, Wed, Thu, Fri, Sat
}

export let ScheduleDaysOfTheWeek = {
  Sun: 'Sun',
  Mon: 'Mon',
  Tue: 'Tue',
  Wed: 'Wed',
  Thu: 'Thu',
  Fri: 'Fri',
  Sat: 'Sat'
};

export let ScheduleLastDayOfMonth = 'Last';
export let ScheduleSecondToLastDayOfMonth = 'SecondToLast';

export let DefinedBy = {
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
  SELF_SERVICE: 'SELF_SERVICE',
};

export interface IMonthlySchedule extends IScheduleDetails {
  startTime: number;              // Time at which the schedule runs. Represented as minutes past midnight.
  recurrenceDayOfMonth: string;   // Day on which the schedule runs. Range : "1", "2", ... "31", "Last"
  recurrenceDaysOfWeek?: string[]; //Day of Week the schedule runs, in this case, the day of month will become the index
}

export interface ISelfServiceScheduleDetails extends IScheduleDetails {
  startTime: number;
  endTime?: number;
  recurrenceMinutes?: number;
  recurrenceDaysOfWeek?: string[];
  recurrenceDayOfMonth?: string;
}

export enum ExecutionType {
  Parallel= 'Parallel',
  Serial= 'Serial',
}

export enum ScheduleAction {
  Extract='Extract',
  Flow='Flow',
  Subscription='Subscription',
  Data_Acceleration='Data_Acceleration',
}

// TODO in TFS1181053: Delete the interfaces below as they will no longer be used by anything
export interface IScheduleViewModel extends IScheduleFrequencyViewModel {
  id?: string;  // Will be undefined for new schedules
  name: string;
  priority: number;
  parallel: boolean;
  scheduledAction: string;
  enabledForLinkedTasks?: boolean;
}

export interface IScheduleFrequencyViewModel {
  scheduleType: string;
  daily: IDailySchedule;
  hourly: IHourlySchedule;
  weekly: IWeeklySchedule;
  monthly: IMonthlySchedule;
  frequencyOptions: IFrequencyOption[];
}

export interface ICreateOrEditScheduleScope extends ng.IScope {
  scheduleActions: string[];
  hourlyFrequencies: ICreateOrEditScheduleSelectOption[];
  daysOfMonth: ICreateOrEditScheduleSelectOption[];
  scheduleViewModel: IScheduleViewModel;
  flowsOnServerEnabled: boolean;
}

export interface ICreateOrEditScheduleSelectOption {
  label: string;
  value: any;
}

export interface IFrequencyOption {
  value: string;
  locKey: string;
}

export const FrequencyOption = {
  Monthly: { value: 'Monthly', locKey: 'monthly' },
  Weekly: { value: 'Weekly', locKey: 'weekly' },
  Daily: { value: 'Daily', locKey: 'daily' },
  Hourly: { value: 'Hourly', locKey: 'hourly' }
};
